module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.activePanel) ? _c('div', {
    staticClass: "sideways-content-fold"
  }, [(_vm.process !== 'next_actions') ? _c('div', {
    staticClass: "portlet light bordered"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "portlet-body portlet-overflow"
  }, [_c('form', {
    attrs: {
      "role": "form",
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.createCampaign($event)
      }
    }
  }, [(_vm.errorMessage.length) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-close": "alert"
    },
    on: {
      "click": function($event) {
        _vm.clearError()
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.process === 'step_1') ? _c('div', {
    key: "step_1"
  }, [_c('div', {
    staticClass: "form-body invite-user-form"
  }, [_c('div', {
    staticClass: "margin-bottom-20"
  }, [_c('label', {
    staticClass: "dropdown-label-override"
  }, [_vm._v("Campaign Type")]), _vm._v(" "), _c('dropdown', {
    attrs: {
      "forceUpdate": _vm.transitionComplete
    }
  }, [_c('button', {
    staticClass: "btn btn-sm btn-outline dropdown-toggle btn-default",
    attrs: {
      "slot": "button",
      "type": "button",
      "data-toggle": "dropdown"
    },
    slot: "button"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.campaignTypes[_vm.newCampaign.campaign_type]) + "\n\t\t\t\t\t\t\t\t\t\t\t"), _c('i', {
    staticClass: "fa fa-angle-down"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "slot": "dropdown-menu"
    },
    slot: "dropdown-menu"
  }, [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setGameType('sw')
      }
    }
  }, [_vm._v("Scratch and Win")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setGameType('ig')
      }
    }
  }, [_vm._v("Instagage")])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newCampaign.name),
      expression: "newCampaign.name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newCampaign.name.length
    },
    attrs: {
      "type": "text",
      "id": "create_campaign_name",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.newCampaign.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newCampaign, "name", $event.target.value.trim())
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "create_campaign_name"
    }
  }, [_vm._v("Campaign Name")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newCampaign.image),
      expression: "newCampaign.image",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newCampaign.image.length
    },
    attrs: {
      "type": "text",
      "id": "create_campaign_image",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.newCampaign.image)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newCampaign, "image", $event.target.value.trim())
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "create_campaign_image"
    }
  }, [_vm._v("Campaign Image")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label no-top-padding"
  }, [_c('label', {
    staticClass: "dropdown-label-override"
  }, [_vm._v("Start On")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "format": 'MMM dd, yyyy h:mm A',
      "type": "datetime",
      "picker-options": _vm.datepickerStartOptions,
      "placeholder": "Select Start Date*",
      "editable": false
    },
    model: {
      value: (_vm.newCampaign.start_date),
      callback: function($$v) {
        _vm.$set(_vm.newCampaign, "start_date", $$v)
      },
      expression: "newCampaign.start_date"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label no-top-padding"
  }, [_c('label', {
    staticClass: "dropdown-label-override"
  }, [_vm._v("End On")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "format": 'MMM dd, yyyy h:mm A',
      "type": "datetime",
      "picker-options": _vm.datepickerEndOptions,
      "placeholder": "Select Start Date*",
      "editable": false
    },
    model: {
      value: (_vm.newCampaign.end_date),
      callback: function($$v) {
        _vm.$set(_vm.newCampaign, "end_date", $$v)
      },
      expression: "newCampaign.end_date"
    }
  })], 1), _vm._v(" "), (_vm.newCampaign.campaign_type === 'sw') ? _c('div', {
    staticClass: "form-md-checkboxes margin-bottom-20"
  }, [_c('div', {
    staticClass: "md-checkbox-inline"
  }, [_c('div', {
    staticClass: "md-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCampaign.alternate_flow),
      expression: "newCampaign.alternate_flow"
    }],
    staticClass: "md-check",
    attrs: {
      "type": "checkbox",
      "id": "checkbox-alternate-flow",
      "disabled": _vm.process !== 'step_1'
    },
    domProps: {
      "checked": Array.isArray(_vm.newCampaign.alternate_flow) ? _vm._i(_vm.newCampaign.alternate_flow, null) > -1 : (_vm.newCampaign.alternate_flow)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newCampaign.alternate_flow,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.newCampaign.alternate_flow = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.newCampaign.alternate_flow = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.newCampaign, "alternate_flow", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkbox-alternate-flow"
    }
  }, [_c('span'), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "box"
  }), _vm._v("\n                    \t\t\t\t\t\t\tUse alternate flow\n                    \t\t\t\t\t\t")]), _vm._v(" "), _c('info-popover', {
    attrs: {
      "content": 'By enabling this, the user will be presented with the prize first and then prompted for their information.'
    }
  })], 1)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-actions noborder invite-user-actions margin-top-20"
  }, [_c('button', {
    staticClass: "btn btn-default exit-invitation-setup",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closePanel()
      }
    }
  }, [_vm._v(" Return To UNOgames Dashboard")]), _vm._v(" "), _c('button', {
    key: "create-campaign-continue-one",
    staticClass: "btn blue",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.advanceForm($event, 'step_2', 'step_1')
      }
    }
  }, [_vm._v("Continue "), _c('i', {
    staticClass: "fa fa-arrow-circle-right"
  })])])]) : _vm._e(), _vm._v(" "), (_vm.process === 'step_2') ? _c('div', {
    key: "step_2"
  }, [_c('div', {
    staticClass: "form-body invite-user-form"
  }, [_c('div', {
    staticClass: "margin-bottom-20"
  }, [_c('label', {
    staticClass: "dropdown-label-override"
  }, [_vm._v("Phone Number")]), _vm._v(" "), _c('dropdown', [_c('button', {
    staticClass: "btn btn-sm btn-outline dropdown-toggle btn-default",
    attrs: {
      "slot": "button",
      "type": "button",
      "data-toggle": "dropdown",
      "disabled": _vm.showKeywordUI
    },
    slot: "button"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s((_vm.newCampaign.details.twilio_account.id) ? _vm.newCampaign.details.twilio_account.phone_number : 'Select a phone number') + "\n\t\t\t\t\t\t\t\t\t\t\t"), _c('i', {
    staticClass: "fa fa-angle-down"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "slot": "dropdown-menu"
    },
    slot: "dropdown-menu"
  }, [_vm._l((_vm.twilioAccounts), function(account) {
    return [_c('li', [_c('a', {
      on: {
        "click": function($event) {
          _vm.setTwilioAccount(account)
        }
      }
    }, [_vm._v(_vm._s(account.phone_number))])])]
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "margin-bottom-20 keyword-section"
  }, [_c('label', {
    staticClass: "dropdown-label-override"
  }, [_vm._v("Campaign Keywords")]), _vm._v(" "), (!_vm.showKeywordUI) ? _c('a', {
    staticClass: "quick-nav-trigger",
    on: {
      "click": function($event) {
        _vm.openKeywordUI()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })]) : _vm._e(), _vm._v(" "), (_vm.showKeywordUI) ? _c('div', {
    staticClass: "portlet box blue-hoki",
    staticStyle: {
      "border-top": "1px solid #869ab3"
    }
  }, [_c('div', {
    staticClass: "portlet-body clearfix"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keywordInput),
      expression: "keywordInput"
    }],
    staticClass: "form-control no-border",
    attrs: {
      "placeholder": "Enter or paste the keywords that the user can text in to enter the contest. Separate your keywords by commas.",
      "rows": "5",
      "id": "keyword-textarea"
    },
    domProps: {
      "value": (_vm.keywordInput)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keywordInput = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm blue pull-right",
    on: {
      "click": function($event) {
        _vm.addKeywords()
      }
    }
  }, [_vm._v("Add Keywords")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "table-scrollable"
  }, [_c('table', {
    staticClass: "table table-hover table-light"
  }, [_c('tbody', [_vm._l((_vm.newCampaign.details.keywords), function(keyword, index) {
    return (_vm.newCampaign.details.keywords.length < 26) ? [_c('tr', [_c('td', [_vm._v(_vm._s(keyword))]), _vm._v(" "), _c('td', {
      staticClass: "center clickable",
      on: {
        "click": function($event) {
          _vm.removeKeyword(index)
        }
      }
    }, [_vm._v("×")])])] : _vm._e()
  }), _vm._v(" "), (_vm.newCampaign.details.keywords.length > 25) ? _c('tr', [_c('td', {
    staticClass: "center"
  }, [_c('small', [_vm._v("You have " + _vm._s(_vm.newCampaign.details.keywords.length) + " keywords.")])])]) : _vm._e(), _vm._v(" "), (!_vm.newCampaign.details.keywords.length) ? _c('tr', [_c('td', {
    staticClass: "center"
  }, [_c('small', [_vm._v("No campaign keywords added.")])])]) : _vm._e()], 2)])])]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "dropdown-label-override"
  }, [_vm._v("Text2Win Type")]), _vm._v(" "), _c('dropdown', [_c('button', {
    staticClass: "btn btn-sm btn-outline dropdown-toggle btn-default",
    attrs: {
      "slot": "button",
      "type": "button",
      "data-toggle": "dropdown",
      "disabled": _vm.showKeywordUI
    },
    slot: "button"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.useTypes[_vm.newCampaign.details.type] || 'Select a Text2Win type')), _c('i', {
    staticClass: "fa fa-angle-down"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "slot": "dropdown-menu"
    },
    slot: "dropdown-menu"
  }, [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setText2WinType('single_use_case')
      }
    }
  }, [_vm._v("Single Use")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setText2WinType('multiple_use_case')
      }
    }
  }, [_vm._v("Multiple Use")])])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-actions noborder invite-user-actions margin-top-60"
  }, [_c('button', {
    staticClass: "btn btn-default exit-invitation-setup",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closePanel()
      }
    }
  }, [_vm._v(" Return To UNOgames Dashboard")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "disabled": _vm.showKeywordUI
    },
    on: {
      "click": function($event) {
        _vm.reverseForm()
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('button', {
    key: "create-campaign-continue-two",
    staticClass: "btn blue",
    attrs: {
      "type": "button",
      "disabled": _vm.showKeywordUI
    },
    on: {
      "click": function($event) {
        _vm.advanceForm($event, 'step_3', 'step_2')
      }
    }
  }, [_vm._v("Continue "), _c('i', {
    staticClass: "fa fa-arrow-circle-right"
  })])])]) : _vm._e(), _vm._v(" "), (_vm.process === 'step_3') ? _c('div', {
    key: "step_3"
  }, [_c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label margin-top-20"
  }, [_c('div', {
    staticClass: "form-body invite-user-form"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCampaign.details.response_message),
      expression: "newCampaign.details.response_message"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newCampaign.details.response_message.length
    },
    attrs: {
      "type": "text",
      "id": "form_control_1"
    },
    domProps: {
      "value": (_vm.newCampaign.details.response_message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newCampaign.details, "response_message", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_1"
    }
  }, [_vm._v("SMS Response "), (_vm.mergeErrorMessage.length) ? _c('small', {
    staticClass: "font-red-thunderbird"
  }, [_vm._v("- " + _vm._s(_vm.mergeErrorMessage))]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "help-block persist"
  }, [_vm._v("The response the user will receive when they text a valid keyword.")])]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "margin-top-40 dropdown-label-override"
  }, [_vm._v("Insert Merge Fields: "), _c('info-popover', {
    attrs: {
      "content": 'Merge Fields will be replaced by the corresponding content when the SMS message is sent.'
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs blue",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.insertMergeField('{EXPIRY_DATE}')
      }
    }
  }, [_vm._v("Expiry Date")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs blue",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.insertMergeField('{SHORT_LINK}')
      }
    }
  }, [_vm._v("Short Link")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label margin-top-20"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCampaign.details.redeem_message),
      expression: "newCampaign.details.redeem_message"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newCampaign.details.redeem_message.length
    },
    attrs: {
      "type": "text",
      "id": "campaign_redeem_message"
    },
    domProps: {
      "value": (_vm.newCampaign.details.redeem_message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newCampaign.details, "redeem_message", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "campaign_redeem_message"
    }
  }, [_vm._v("Redeemed Response")]), _vm._v(" "), _c('span', {
    staticClass: "help-block persist"
  }, [_vm._v("The response the user will receive if they have exceeded the entry limit.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label margin-top-40"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCampaign.details.expiry_message),
      expression: "newCampaign.details.expiry_message"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newCampaign.details.expiry_message.length
    },
    attrs: {
      "type": "text",
      "id": "campaign_expired_response"
    },
    domProps: {
      "value": (_vm.newCampaign.details.expiry_message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newCampaign.details, "expiry_message", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "campaign_expired_response"
    }
  }, [_vm._v("Campaign Expired Response")]), _vm._v(" "), _c('span', {
    staticClass: "help-block persist"
  }, [_vm._v("The response the user will receive if the campaign has expired.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label margin-top-40"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCampaign.details.exceeded_message),
      expression: "newCampaign.details.exceeded_message"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newCampaign.details.exceeded_message.length
    },
    attrs: {
      "type": "text",
      "id": "campaign_max_response"
    },
    domProps: {
      "value": (_vm.newCampaign.details.exceeded_message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newCampaign.details, "exceeded_message", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "campaign_max_response"
    }
  }, [_vm._v("Max Exceeded Response")]), _vm._v(" "), _c('span', {
    staticClass: "help-block persist"
  }, [_vm._v("The response the user will receive if the maximum redemption limits have been exceeded.")])]), _vm._v(" "), (_vm.newCampaign.campaign_type !== 'ig') ? _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label margin-top-40"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCampaign.details.max_redemptions),
      expression: "newCampaign.details.max_redemptions"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newCampaign.details.max_redemptions !== null
    },
    attrs: {
      "type": "number",
      "id": "campaign_max_redemptions"
    },
    domProps: {
      "value": (_vm.newCampaign.details.max_redemptions)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newCampaign.details, "max_redemptions", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "campaign_max_redemptions"
    }
  }, [_vm._v("Max Entries for Campaign "), _c('small', {
    staticClass: "font-grey-cascade"
  }, [_vm._v("(Use ‘0’ if unlimited)")])]), _vm._v(" "), _c('span', {
    staticClass: "help-block persist"
  }, [_vm._v("The maximum number of entries for the entire campaign.")])]) : _vm._e(), _vm._v(" "), (_vm.newCampaign.campaign_type !== 'ig') ? _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label margin-top-40"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCampaign.details.max_redemptions_per_day),
      expression: "newCampaign.details.max_redemptions_per_day"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newCampaign.details.max_redemptions_per_day !== null
    },
    attrs: {
      "type": "number",
      "id": "campaign_max_per_day"
    },
    domProps: {
      "value": (_vm.newCampaign.details.max_redemptions_per_day)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newCampaign.details, "max_redemptions_per_day", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "campaign_max_per_day"
    }
  }, [_vm._v("Max Entries Per Day "), _c('small', {
    staticClass: "font-grey-cascade"
  }, [_vm._v("(Use ‘0’ if unlimited)")])]), _vm._v(" "), _c('span', {
    staticClass: "help-block persist"
  }, [_vm._v("The maximum number of entries allowed for a campaign in a single day for ALL users.")])]) : _vm._e(), _vm._v(" "), (_vm.newCampaign.campaign_type !== 'ig') ? _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label margin-top-40"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCampaign.details.max_redemptions_per_day_per_user),
      expression: "newCampaign.details.max_redemptions_per_day_per_user"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newCampaign.details.max_redemptions_per_day_per_user !== null
    },
    attrs: {
      "type": "number",
      "id": "campaign_max_per_day_per_user"
    },
    domProps: {
      "value": (_vm.newCampaign.details.max_redemptions_per_day_per_user)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newCampaign.details, "max_redemptions_per_day_per_user", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "campaign_max_per_day_per_user"
    }
  }, [_vm._v("Max Entries Per Day/Per User "), _c('small', {
    staticClass: "font-grey-cascade"
  }, [_vm._v("(Use ‘0’ if unlimited)")])]), _vm._v(" "), _c('span', {
    staticClass: "help-block persist"
  }, [_vm._v("The maximum number of entries allowed for a campaign in a single day for a SINGLE user.")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-body invite-user-form"
  }, [_c('div', {
    staticClass: "form-actions noborder invite-user-actions margin-top-60"
  }, [_c('button', {
    staticClass: "btn btn-default exit-invitation-setup",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closePanel()
      }
    }
  }, [_vm._v(" Return To UNOgames Dashboard")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.reverseForm()
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('button', {
    key: "create-campaign-confirm",
    staticClass: "btn blue",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Submit")])])])]) : _vm._e()]), _vm._v(" "), _c('step-counter', {
    attrs: {
      "steps": _vm.steps,
      "process": _vm.process
    }
  })], 1)])]) : _c('next-actions', {
    attrs: {
      "actionsList": _vm.createCampaignNextActions
    },
    on: {
      "runFunction": _vm.runFunction
    }
  })], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption"
  }, [_vm._v("\n\t\t\t\t\tCreate A Campaign\n\t\t\t\t")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2a5c07c2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/UNOgames/CreateCampaign.vue
// module id = 415
// module chunks = 1